import { render } from "./ChosenProductInfo.vue?vue&type=template&id=4fe4032a&scoped=true&ts=true"
import script from "./ChosenProductInfo.vue?vue&type=script&lang=ts"
export * from "./ChosenProductInfo.vue?vue&type=script&lang=ts"

import "./ChosenProductInfo.vue?vue&type=style&index=0&id=4fe4032a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe4032a"]])

export default __exports__